/* eslint-disable no-await-in-loop */
import { expect } from '@open-wc/testing';
import {
  executeServerCommand,
  sendKeys,
  sendMouse,
} from '@web/test-runner-commands';
import '../src/testHarness.js';
import {
  fixtureBeforeEach,
  fixtureBefore,
  fixtureAfterEach,
  TelemInfo,
  screenshotAndCompare,
  mockDataMeta,
} from './utils/helpers.js';

const toggleExpandAllGroups = async () => {
  const groupedItems: TelemInfo[] = await executeServerCommand(
    'mouseFocusInfo',
    {
      selector: 'grouped-item',
      action: 'info',
    }
  );

  const groupedItemsExpandPosProms = groupedItems.map(
    async (_item: TelemInfo, i: number) => {
      const itemMousePos: [number, number] = await executeServerCommand(
        'mouseFocusInfo',
        {
          selector: `grouped-item:nth-child(${
            i + 1
          }) [data-testclass="grouped-item-toggle-expand"]`,
          action: 'mouse',
        }
      );

      return itemMousePos;
    }
  );

  const groupedItemsExpandMousePos: [number, number][] = await Promise.all(
    groupedItemsExpandPosProms
  );

  for (const pos of groupedItemsExpandMousePos.reverse()) {
    // reverse the array to prevent element from moving
    await sendMouse({
      type: 'click',
      position: pos,
    });
  }
};

describe('group notifications', () => {
  before(async () => {
    await fixtureBefore();
  });

  beforeEach(async () => {
    await fixtureBeforeEach();

    await executeServerCommand('mouseFocusInfo', {
      selector: '[data-testid="notifications-cta-sort-type"] md-icon-button',
    });

    await sendKeys({
      press: 'Space',
    });
  });

  afterEach(async () => {
    fixtureAfterEach();
  });

  it('should toggle grouped items', async () => {
    let groupedItemsInfo: TelemInfo[] = await executeServerCommand(
      'mouseFocusInfo',
      {
        selector: 'grouped-item',
        action: 'info',
      }
    );

    expect(groupedItemsInfo.length).to.equal(4);

    await screenshotAndCompare('grouped-items');

    await sendKeys({
      press: 'Space',
    });

    groupedItemsInfo = await executeServerCommand('mouseFocusInfo', {
      selector: 'grouped-item',
      action: 'info',
    });

    expect(groupedItemsInfo.length).to.equal(0);

    await screenshotAndCompare('ungrouped-items');
  });

  it('should expand and collapse items in groups', async () => {
    let notificationItems: TelemInfo[] = await executeServerCommand(
      'mouseFocusInfo',
      {
        selector: 'notification-item',
        action: 'info',
      }
    );

    expect(notificationItems.length).to.equal(0);

    await toggleExpandAllGroups();

    notificationItems = await executeServerCommand('mouseFocusInfo', {
      selector: 'notification-item',
      action: 'info',
    });

    expect(notificationItems.length).to.equal(mockDataMeta.itemsCount);

    await screenshotAndCompare('expanded-group-items');

    await toggleExpandAllGroups();

    notificationItems = await executeServerCommand('mouseFocusInfo', {
      selector: 'notification-item',
      action: 'info',
    });

    expect(notificationItems.length).to.equal(0);

    await screenshotAndCompare('collapsed-group-items');
  });

  it('should have the appropriate number of items in each group', async () => {
    await toggleExpandAllGroups();

    let notificationItems: TelemInfo[] = await executeServerCommand(
      'mouseFocusInfo',
      {
        selector: '[data-testid="planned-maintenance-group"] notification-item',
        action: 'info',
      }
    );

    expect(notificationItems.length).to.equal(
      mockDataMeta.plannedMaintenanceCount
    );

    notificationItems = await executeServerCommand('mouseFocusInfo', {
      selector: '[data-testid="emergency-repairs-group"] notification-item',
      action: 'info',
    });

    expect(notificationItems.length).to.equal(mockDataMeta.incidentsCount);

    notificationItems = await executeServerCommand('mouseFocusInfo', {
      selector:
        '[data-testid="service-ticket-updates-group"] notification-item',
      action: 'info',
    });

    expect(notificationItems.length).to.equal(mockDataMeta.serviceTicketsCount);

    notificationItems = await executeServerCommand('mouseFocusInfo', {
      selector: '[data-testid="dcim-alerts-group"] notification-item',
      action: 'info',
    });

    expect(notificationItems.length).to.equal(mockDataMeta.dcimAlertsCount);
  });
});
